export default __webpack_public_path__ + "static/media/GenesisLabs.6cafee28.png";